<uni-status
  [status]="validateInput(value)"
  margin="fixed"
>
  <ng-content></ng-content>
</uni-status>
